import { ServiceType } from '@shared/searchBar';
import { TAB_MENU_LIST } from '@shared/searchBar/tabMenu';

export const getServiceId = (key: ServiceType) =>
  TAB_MENU_LIST.find((item) => item?.key === key)?.id || 1;
